import filterForOwner from './filterForOwner';

const ripToJSON = (rip) => (rip.toJSON ? rip.toJSON() : rip);

const getRipFor = (rip, owner) => (('cohabitation' === rip.familySituation && rip.dualRip)
    ? filterForOwner(ripToJSON(rip), owner)
    : ripToJSON(rip));

export default getRipFor;
